<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active ">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">

            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
              <span class="mdi mdi-menu"></span>
            </button>

            <div class="collapse navbar-collapse justify-content-between active scrollable-navbar"
                 id="navbarNavAltMarkup">
              <div class="navbar-nav flex-nowrap">
                <router-link v-if="getRight('SBP DASHBOARD')" :to="{name: 'cert-biz-stats'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bxs-dashboard me-1"></i> Dashboard
                </router-link>
                <router-link v-if="getRight('SBP PERFORMANCE')" :to="{name: 'sbp-performance-dashboard'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-trending-up me-1"></i> Performance
                </router-link>
                <router-link v-if="getRight('SBP BUSINESS TYPES')" :to="{name: 'business-type-analytics'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-category me-1"></i> Business Types
                </router-link>
                <router-link v-if="getRight('SBP VALIDATION PAGE')" :to="{name: 'pending-validation'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-check-circle me-1"></i> Pending Validation
                </router-link>
                <router-link v-if="getRight('SBP INSPECTION PAGE')" :to="{name: 'pending-inspection'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-search-alt me-1"></i> Pending Inspection
                </router-link>
                <router-link v-if="getRight('SBP APPROVAL PAGE')" :to="{name: 'pending-approval'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-badge-check me-1"></i> Pending Approval
                </router-link>
                <router-link v-if="getRight('SBP DECLINED')" :to="{name: 'declined'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-x-circle me-1"></i> Declined
                </router-link>
                <router-link v-if="getRight('SBP APPROVED')" :to="{name: 'approved'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-check-shield me-1"></i> Approved
                </router-link>
                <router-link v-if="getRight('SBP EXPIRED')" :to="{name: 'expired'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-time-five me-1"></i> Expired
                </router-link>
                <router-link v-if="getRight('SBP UNPAID')" :to="{name: 'unpaid-sbp'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-money me-1"></i> Unpaid SBPs
                </router-link>
                <router-link v-if="getRight('SBP PENDING BILLS')" :to="{name: 'sbp-unpaid-bills'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-receipt me-1"></i> Invoices
                </router-link>
                <router-link v-if="getRight('SBP RECEIPTS')" :to="{name: 'sbp-paid-bills'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-file me-1"></i> SBP Receipt
                </router-link>
                <router-link v-if="getRight('SBP MAP VIEW')" :to="{name: 'sbp-map'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-map me-1"></i> Map View
                </router-link>
                <router-link v-if="getRight('SBP SUB COUNTY MAP VIEW')" :to="{name: 'sbp-map-filter'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-map-alt me-1"></i> Sub County Map View
                </router-link>
                <router-link v-if="getRight('BUSINESS REGISTRY')" :to="{name: 'business-register'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-book-open me-1"></i> Business Registry
                </router-link>
                <router-link v-if="getRight('SBP ENFORCEMENT')" :to="{name: 'sbp-enforcement'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-shield-quarter me-1"></i> Enforcement
                </router-link>
                <router-link v-if="getRight('BULK INVOICING')" :to="{name: 'previous-register'}" active-class="mm-active" class="nav-item nav-link text-nowrap">
                  <i class="bx bx-history me-1"></i> previous-register
                </router-link>

                <a v-if="getRight('SBP BULK INVOICING')" @click="gotTo('bulk-invoicer')" href="javascript: void(0);" title="create invoice s in bulk" type="button" class="btn btn-success waves-effect waves-light text-uppercase text-nowrap ms-3">
                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Bulk Invoicing Manager
                </a>

              </div>
            </div>

          </nav>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getRight} from "@/api";

export default {
  name: "ToolBar",
  data() {
    return {
      selectedSub: null,
      // Route-to-role mapping for auto-redirect
      routeRoleMap: [
        { route: 'cert-biz-stats', role: 'SBP DASHBOARD' },
        { route: 'sbp-performance-dashboard', role: 'SBP PERFORMANCE' },
        { route: 'business-type-analytics', role: 'SBP BUSINESS TYPES' },
        { route: 'pending-validation', role: 'SBP VALIDATION PAGE' },
        { route: 'pending-inspection', role: 'SBP INSPECTION PAGE' },
        { route: 'pending-approval', role: 'SBP APPROVAL PAGE' },
        { route: 'declined', role: 'SBP DECLINED' },
        { route: 'approved', role: 'SBP APPROVED' },
        { route: 'expired', role: 'SBP EXPIRED' },
        { route: 'unpaid-sbp', role: 'SBP UNPAID' },
        { route: 'sbp-unpaid-bills', role: 'SBP PENDING BILLS' },
        { route: 'sbp-paid-bills', role: 'SBP RECEIPTS' },
        { route: 'sbp-map', role: 'SBP MAP VIEW' },
        { route: 'sbp-map-filter', role: 'SBP SUB COUNTY MAP VIEW' },
        { route: 'business-register', role: 'BUSINESS REGISTRY' },
        { route: 'sbp-enforcement', role: 'SBP ENFORCEMENT' },
        { route: 'previous-register', role: 'BULK INVOICING' }
      ]
    }
  },
  mounted() {
    this.selectedSub = sessionStorage.getItem("selectedSub");
    this.autoRedirectIfNoAccess();
  },
  methods:{
    getRight(type){
      return getRight(type)
    },
    gotTo(route){
      this.$router.push(route);
      sessionStorage.setItem("selectedSub", route)
      this.selectedSub = route
    },
    autoRedirectIfNoAccess() {
      const currentRoute = this.$route.name;
      // Find the role required for the current route
      const currentMapping = this.routeRoleMap.find(m => m.route === currentRoute);

      // If current route has a role requirement and user doesn't have it
      if (currentMapping && !getRight(currentMapping.role)) {
        // Find the first route the user has access to
        const firstAccessible = this.routeRoleMap.find(m => getRight(m.role));
        if (firstAccessible && firstAccessible.route !== currentRoute) {
          this.$router.replace({ name: firstAccessible.route });
        }
      }
    }
  }
}
</script>

<style scoped>
/* Make the navbar scrollable horizontally */
.scrollable-navbar {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  scrollbar-width: thin; /* Firefox */
}

/* Style for webkit browsers (Chrome, Safari, Edge) */
.scrollable-navbar::-webkit-scrollbar {
  height: 6px;
}

.scrollable-navbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.scrollable-navbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.scrollable-navbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Prevent navbar items from wrapping */
.navbar-nav.flex-nowrap {
  flex-wrap: nowrap !important;
}

/* Ensure nav links have proper spacing and don't break */
.navbar-nav .nav-link {
  padding: 0.5rem 1rem;
  white-space: nowrap;
}

/* Active link styling */
.navbar-nav .nav-link.mm-active {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* Smooth scrolling */
.scrollable-navbar {
  scroll-behavior: smooth;
}

/* Optional: Add fade effect on edges to indicate scrollability */
.scrollable-navbar::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 100%;
  background: linear-gradient(to left, var(--bs-primary), transparent);
  pointer-events: none;
}
</style>